import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useUIStore } from '~/store/useUIStore';
import { ActionConfirmation } from '~/components/auth/components/ActionConfirmation';
import { useUser } from '~/hooks/useUser';
import { useUserData } from '~/hooks/useUserData';

/**
 * Standalone modal for showing action confirmation.
 *
 * Used by useHomeAction for logged-in users with complete profiles
 * to show confirmation directly without going through the login form.
 */
export const ActionConfirmationModal = () => {
  const { user: appUser } = useUser();
  // Use SWR-based user data so counts update when mutate(['users', userId]) is called
  const swrUser = useUserData();
  const user = swrUser || appUser;
  const modals = useUIStore((state) => state.modals);
  const setModals = useUIStore((state) => state.setModals);
  const { isOpen, home, project, action, email } =
    modals.actionConfirmationOpen;

  const onClose = () => {
    setModals({
      ...modals,
      actionConfirmationOpen: {
        isOpen: false,
        home: null,
        project: null,
        action: null,
        email: '',
      },
    });
  };

  if (!action) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} returnFocusOnClose={false}>
      <ModalOverlay />
      <ModalContent
        my={{ base: '0', md: 'auto' }}
        mt={{ base: '33vh', md: 'auto' }}
        mb={{ base: 'auto', md: 'auto' }}
      >
        <ModalCloseButton size="lg" />
        <ActionConfirmation
          action={action}
          home={home || undefined}
          project={project || undefined}
          onClose={onClose}
          email={email}
          homeStatus={home?.status?.name}
          user={user}
        />
      </ModalContent>
    </Modal>
  );
};
